import { Component } from '@angular/core';

@Component({
  selector: 'common-chat-close-icon',
  standalone: true,
  templateUrl: './chat-close-icon.component.svg',
  styleUrls: ['./chat-close-icon.component.scss'],
})
export class ChatCloseIconComponent {
  constructor() {}
}
